import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import Solution from "./Solution";
import UserRoles from "./SolutionRoles";
import Requirements from "./Requirements";
import SolutionTasks from "./SolutionTasks";
import SolutionUsers from "./SolutionUsers";
import WorkFlows from "./WorkFlows";
import { Header } from '../Header';
import { Footer } from '../Footer';
import { NavLink } from 'react-router-dom';

export default class Solutions extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: 'solution',
            data: null,
            loading: true,
            configName: 'solutions_grid',
            moduleName: 'پروژه ها',
            systemModuleId: 24,
            moduleAccessStatus: 1
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.addKeyDown();
                this.refreshData();
            });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Solution Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Solution Caller={this} /> });
    }
    showUserRoles(solutionId) {
        this.removeKeyDown();
        this.showComponents({ component: <UserRoles Caller={this} SolutionId={solutionId} /> });
    }
    showWorkFlows(solutionId) {
        this.removeKeyDown();
        this.showComponents({ component: <WorkFlows Caller={this} SolutionId={solutionId} /> });
    }
    showRequirments(solutionId) {
        this.removeKeyDown();
        this.showComponents({ component: <Requirements Caller={this} SolutionId={solutionId} /> });
    }
    showTasks(solutionId) {
        this.removeKeyDown();
        this.showComponents({ component: <SolutionTasks Caller={this} SolutionId={solutionId} /> });
    }
    showUsers(solutionId) {
        this.removeKeyDown();
        this.showComponents({ component: <SolutionUsers Caller={this} SolutionId={solutionId} /> });
    }
    renderForm() {
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a onClick={e => this.onAdd()} className="hand btn btn-primary"><em className="icon ni ni-plus"></em><span>افزودن پروژه جدید</span></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    {this.isEmpty(this.state.data.records) ?
                        <div className="card card-bordered card-stretch">
                            <div className="card-inner-group">
                                <div className="example-alert">
                                    <div className="alert alert-pro alert-warning">
                                        <div className="alert-text">
                                            <h6>توجه</h6>
                                            <p>شما در حال حاضر هیچ پروژه ای ایجاد نکرده اید</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="row g-gs">
                            {this.state.data.records.map((record, index) =>
                                <div className="col-sm-6 col-lg-6 col-xxl-3">
                                    <div className="card card-bordered h-100">
                                        <div className="card-inner">
                                            <div className="project">
                                                <div className="project-head">
                                                    <a onClick={e => this.onEdit(record.id)} className="hand project-title">
                                                        <div className="project-info">
                                                            <h6 className="title"><a className="hand" onClick={e => this.onEdit(record.id)}>{record.title}</a></h6>
                                                            <span className="sub-text">ایجاد: {record.createDateString}</span>
                                                        </div>
                                                    </a>
                                                    {record.isOwner && <div className="drodown">
                                                        <a href="#" className="dropdown-toggle btn btn-sm btn-icon btn-trigger mt-n1 me-n1" data-bs-toggle="dropdown" aria-expanded="false"><em className="icon ni ni-more-h"></em></a>
                                                        <div className="dropdown-menu dropdown-menu-end">
                                                            <ul className="link-list-opt no-bdr">
                                                                <li><a onClick={e => this.showUsers(record.id)} className="hand"><em className="icon ni ni-users"></em><span>کاربران پروژه</span></a></li>
                                                            </ul>
                                                        </div>
                                                    </div>}
                                                </div>
                                                <div className="project-meta">
                                                    <a onClick={e => this.showUserRoles(record.id)} className="hand">
                                                        <span className="nk-menu-text"><em className="icon ni ni-report-profit"></em> نقش ها</span>
                                                    </a>
                                                    <a onClick={e => this.showWorkFlows(record.id)} className="hand text-success">
                                                        <span className="nk-menu-text"><em className="icon ni ni-bell"></em> گردش های کاری</span>
                                                    </a>
                                                    <a onClick={e => this.showRequirments(record.id)} className="hand text-warning">
                                                        <span className="nk-menu-text"><em className="icon ni ni-calender-date"></em> نیازمندی ها</span>
                                                    </a>
                                                    <a onClick={e => this.showTasks(record.id)} className="hand text-danger">
                                                        <span className="nk-menu-text"><em className="icon ni ni-coin-alt"></em> وظایف</span>
                                                    </a>
                                                    <NavLink to={"/solution/board/" + record.id + "/"} className="hand text-black">
                                                        <span className="nk-menu-text"><em className="icon ni ni-list"></em> بورد</span>
                                                    </NavLink>
                                                    <a className="hand text-danger" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف">
                                                        <span className="nk-menu-text"><em className="icon ni ni-na"></em> حذف صورتحساب</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    }
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}